'use strict';
const cryptoRandomString = require('crypto-random-string');

module.exports = () => cryptoRandomString(32);



//////////////////
// WEBPACK FOOTER
// ./~/unique-string/index.js
// module id = 1839
// module chunks = 0 1 3